// import { Pie } from 'react-chartjs-2';

// const JumlahPembaca = ({chartDataPembaca}) => {
//   return (
//     <div className='chart-container'>
//         <Pie
//         data={chartDataPembaca}
//         options={{ 
//             plugins: {
//                 title: {
//                     display: true,
//                 }
//             }
//          }}/>
//     </div>
//   )
// }

// export default JumlahPembaca

import React from 'react'
import { Pie } from 'react-chartjs-2';

const JumlahPembaca = ({ chartDataPembaca }) => {
  return (
    <div className='chart-container'>
        <Pie
        data={chartDataPembaca}
        options={{ 
            plugins: {
                title: {
                    display: true,
                }
            }
         }}/>
    </div>
  )
}

export default JumlahPembaca